// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__9D2Mb","content":"styles_content__17x19","sub":"styles_sub__Onn5w"};